'use client';

import * as SubframeCore from '@subframe/core';
import { FeatherFileText } from '@subframe/core';
import React from 'react';
import * as SubframeUtils from '../utils';

interface ActionCardRootProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}

const ActionCardRoot = React.forwardRef<HTMLDivElement, ActionCardRootProps>(
  function ActionCardRoot(
    {
      icon = <FeatherFileText />,
      title,
      description,
      className,
      ...otherProps
    }: ActionCardRootProps,
    ref,
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          'group/e2eb418b hover:bg-brand-50 flex w-full cursor-pointer flex-col items-start gap-1 px-3 py-3 hover:rounded-[16px]',
          className,
        )}
        ref={ref}
        {...otherProps}
      >
        <div className="flex w-full items-center gap-3">
          <div className="bg-brand-50 flex h-10 w-10 flex-none items-center justify-center rounded-[16px]">
            {icon ? (
              <SubframeCore.IconWrapper className="text-heading-2 font-heading-2 text-brand-600">
                {icon}
              </SubframeCore.IconWrapper>
            ) : null}
          </div>
          <div className="flex shrink-0 grow basis-0 flex-col items-start gap-0.5">
            {title ? (
              <span className="text-body-bold font-body-bold text-default-font w-full">
                {title}
              </span>
            ) : null}
            {description ? (
              <span className="text-caption font-caption text-subtext-color w-full">
                {description}
              </span>
            ) : null}
          </div>
        </div>
      </div>
    );
  },
);

export const ActionCard = ActionCardRoot;
